// AIT-529 — shared surface for the invite flow's standalone screens
// (/invite/:slug consent, /invite/connect, /invite/done).
//
// These pages are seen by external clients who may never open the app, so
// they follow the marketing site's DESIGN.md language (dark #1C1E21 surface,
// Meta Blue glow, Montserrat, 20px card radius) — NOT the internal app shell.

export function PageShell({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#1C1E21] p-6"
      style={{ fontFamily: "'Montserrat', ui-sans-serif, system-ui, sans-serif" }}
    >
      {/* Meta Blue ambient glow, same treatment as the marketing hero */}
      <div className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-[#0064E0]/15 blur-[140px]" />

      {children}
    </div>
  );
}
